<script setup>
const props = defineProps({
  blocks: Array,
  textColor: String,
});
</script>

<template>
  <div
    class="project-content"
    :class="
      (blocks[blocks.length - 1].type === 'textImage' &&
        blocks[blocks.length - 1].bgColor ||blocks[blocks.length - 1].bgGradient ) ||
      (blocks[blocks.length - 1].type === 'image' &&
        !blocks[blocks.length - 1].spacingBottom)
        ? ''
        : ' pb-xl'
    "
  >
    <template v-for="block in blocks">
      <ProjectContentTypesText
        v-if="block.type === 'text'"
        :text="block.text?.content"
        :textColor="textColor"
        :button="block.button"
      />
      <ProjectContentTypesImage
        v-else-if="block.type === 'image'"
        :image="block.image"
        :spacingBottom="block.spacingBottom"
        :imageHasBorder="block.imageHasBorder"
        :imageFullWidth="block.imageFullWidth"
      />
      <ProjectContentTypesVideo
        v-else-if="block.type === 'video'"
        :video="block.video"
      />
      <ProjectContentTypesTextImage
        v-else-if="block.type === 'textImage'"
        :text="block.text?.content"
        :textColor="block.textColor ? block.textColor : textColor"
        :bgColor="block.bgColor"
        :bgGradient="block.bgGradient"
        :textPosition="block.text?.position"
        :image="block.image"
        :imagePositionLeft="block.imagePositionLeft"
        :imagePositionRight="block.imagePositionRight"
        :imageHasBorder="block.imageHasBorder"
        :button="block.button"
      />
      <ProjectContentTypesTextVideo
        v-else-if="block.type === 'textVideo'"
        :text="block.text?.content"
        :textColor="textColor"
        :textPosition="block.text?.position"
        :video="block.video"
        :button="block.button"
      />
      <ProjectContentTypesCarrousel
        v-else-if="block.type === 'carrousel'"
        :carrousel="'carrousel'"
      />
    </template>
  </div>
</template>

<style>
.project-content {
  h1,
  .h1 {
    @apply text-3xl sm:text-4xl xl:text-5xl;
  }

  h2,
  .h2 {
    @apply text-2xl sm:text-3xl xl:text-4xl;
  }
  h3,
  .h3 {
    @apply text-lg md:text-xl xl:text-3xl;
  }
  h4,
  .h4 {
    @apply text-base sm:text-lg;
  }
}
</style>
